import { render } from "./Footer.vue?vue&type=template&id=2d2d5a1a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2d2d5a1a&scoped=true&lang=css"

import exportComponent from "/Users/yinhu/code/jugu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2d5a1a"]])

export default __exports__